import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<HttpEvent<any>>> {
    const excludedUrls = [
      'sanna-prod-obtener-licencia-rut',
      'api-de-autenticacion',
      'tokenProxyUrl'
    ];

    // Si la URL está en la lista de exclusión, no tocar headers
    const shouldSkip = excludedUrls.some(url => req.url.includes(url));

    if (shouldSkip) {
      return next.handle(req); // 👉 deja pasar la request intacta
    }

    const token: string = localStorage.getItem('CapacitorStorage.token');
    const headers = token ? new HttpHeaders({ 'Authorization': `Bearer ${token}` }) : undefined;
    const modifiedRequest = headers ? req.clone({ headers }) : req;
    return next.handle(modifiedRequest);
  }
}
